module.exports = __webpack_public_path__ + "static/media/redeemSwitch.cdb7fc67.svg";